
import Nem from "../../../assets/duotone/Nem.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function NemIcon({ className, dataTestid = "NemIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Nem data-testid={dataTestid} className={classes} {...rest} />
  );
}
